module.exports = __webpack_public_path__ + "img/logo.8c2493b9.svg";